import { render, staticRenderFns } from "./NetworkStatus.vue?vue&type=template&id=8e0edc72&scoped=true"
import script from "./NetworkStatus.vue?vue&type=script&lang=js"
export * from "./NetworkStatus.vue?vue&type=script&lang=js"
import style0 from "./NetworkStatus.vue?vue&type=style&index=0&id=8e0edc72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e0edc72",
  null
  
)

export default component.exports